<template>
  <main class="wallet-select-coin-page">
    <AppNavBar :title="t('wallet.chooseCoin')" />

    <section class="coin-list">
      <button
        v-for="(item, index) in coins"
        :key="item.symbol || index"
        class="coin-card"
        :class="{ active: selectedIndex === index }"
        type="button"
        @click="selectedIndex = index"
      >
        <div class="coin-card__content">
          <app-image :src="item.logo || usdtIcon" alt="" />
          <div data-strong>{{ item.symbol || '--' }}</div>
        </div>
      </button>
    </section>

    <div class="submit-wrap">
      <van-button block round type="primary" @click="confirmSelect">
        {{ t('common.confirm') }}
      </van-button>
    </div>
  </main>
</template>

<script setup>
import { computed, onMounted, ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import { showFailToast } from 'vant';
import { useProfileStore } from '@/stores/profile';
import { useWalletWithdrawStore } from '@/stores/wallet-withdraw';
import usdtIcon from '@/assets/images/usdt.png';

const { t } = useI18n();
const router = useRouter();
const profileStore = useProfileStore();
const walletWithdrawStore = useWalletWithdrawStore();

const selectedIndex = ref(walletWithdrawStore.selectedCoinIndex);
const coins = computed(() => walletWithdrawStore.list);

watch(
  () => walletWithdrawStore.selectedCoinIndex,
  (value) => {
    selectedIndex.value = value;
  }
);

async function loadData() {
  try {
    await walletWithdrawStore.fetchWithdrawInfo({
      address: profileStore.platformAddress || null,
      reset: !walletWithdrawStore.list.length
    });
  } catch (error) {
    showFailToast(error?.msg || t('common.retryLater'));
  }
}

function confirmSelect() {
  walletWithdrawStore.setSelectedCoinIndex(selectedIndex.value);
  router.back();
}

onMounted(loadData);
</script>

<style scoped lang="scss">
.wallet-select-coin-page {
  min-height: var(--app-viewport-height);
  padding: 0 15px 112px;
  background: #f7f7f7;
}

.coin-list {
  padding-top: 8px;
}

.coin-card {
  width: 100%;
  margin-top: 8px;
  padding: 12px 16px;
  border: 1px solid #ffffff;
  border-radius: 12px;
  background: #ffffff;
  text-align: left;

  &.active {
    border-color: var(--van-primary-color);
  }
}

.coin-card__content {
  display: flex;
  align-items: center;

  .app-image {
    width: 44px;
    height: 44px;
    margin-right: 8px;
    border-radius: 50%;
    object-fit: cover;
  }

  [data-strong] {
    color: #000000;
    font-size: 16px;
    font-weight: 700;
  }
}

.submit-wrap {
  position: fixed;
  right: 15px;
  bottom: 24px;
  left: 15px;
}
</style>
